import Vue from 'vue'
import "vue-easytable/libs/theme-default/index.css"; // import style
import VueEasytable, { VeLocale } from "vue-easytable"; // import library
// import language config
import ptBR from "vue-easytable/libs/locale/lang/pt-BR.js";

Vue.use(VueEasytable);
VeLocale.use(ptBR);
